module.exports = "/ada933871f6eb9d3341d1822d1741746.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/brands/ben-jerry.png
 ** module id = 2202
 ** module chunks = 0
 **/